import { CCStyling } from "../cclib/CCStyling";
import { CCStructureItem } from "../cclib/types/structure";

export const demoCCStructure: CCStructureItem[] = [
  {
    name: "Colleague Name",
    type: "string",
    key: "colleague_name",
    readOnly: true
  },
  {
    type: "grid",
    rows: 2,
    columns: 2,
    additionalCss: CCStyling.fromObject({
      "margin-bottom": "5px",
      width: "min(510px, 100%)",
      "grid-template-columns": "1fr 1fr",
      gap: "0px 0px"
    }),
    sections: [
      {
        name: "Colleague Job Title",
        type: "string",
        orientation: "vertical",
        key: "job_title"
      },
      {
        name: "Start Date",
        orientation: "vertical",
        type: "date",
        key: "job_start_date"
      },
      {
        name: "Secondary Job Title (optional)",
        type: "string",
        orientation: "vertical",
        key: "secondary_job_title",
        optional: true
      },
      {
        name: "Start Date",
        type: "date",
        orientation: "vertical",
        key: "secondary_job_start_date",
        optional: true
      }
    ]
  },
  {
    name: "Academic Rank",
    type: "string",
    key: "academic_rank",
    readOnly: true
  },
  {
    name: "Time in Academic Rank (Years)",
    type: "string",
    key: "time_in_position",
    readOnly: true
  },
  {
    name: "Appraiser's Name",
    type: "string",
    key: "appraiser_name",
    readOnly: true
  },
  {
    name: "Appraisal Period",
    type: "string",
    key: "appraisal_period",
    readOnly: true
  },
  { name: "Colleague ID", type: "string", key: "colleague_id" },
  {
    name: "Department Name",
    type: "string",
    key: "department_name",
    readOnly: true
  },
  {
    name: "Date Appraisal Completed",
    type: "string",
    key: "date_appraisal_completed",
    readOnly: true,
    optional: true
  },
  { name: "Job Satisfaction / Burnout", type: "header" },
  {
    name: "How would you rate your overall job satisfaction for the past 12 months (scale worst 1-10 best)",
    type: "select",
    key: "jobs_satisfaction_current",
    options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
  },
  {
    name: "Last year's rating",
    type: "string",
    optional: true,
    readOnly: true,
    key: "jobs_satisfaction_current_prev"
  },
  {
    name: "Comments on job satisfaction",
    type: "paragraph",
    key: "jobs_satisfaction_comments",
    optional: true
  },
  { name: "Do you feel burned out?", type: "header" },
  {
    name: "This year: (Yes/No)",
    type: "select",
    key: "burnout_current",
    options: ["Yes", "No"]
  },
  {
    name: "Last year: (Yes/No)",
    type: "string",
    optional: true,
    readOnly: true,
    key: "burnout_current_prev"
  },
  {
    name: "Comments on burnout",
    type: "paragraph",
    key: "burnout_comments",
    optional: true
  },
  {
    name: "Appraiser Comments",
    type: "paragraph",
    key: "jobs_satisfaction_appraiser_comments",
    isMentorField: true,
    optional: true
  },
  { name: "Job Satisfiers / Dis-satisfiers", type: "header" },
  { name: "Job Satisfiers", type: "paragraph", key: "job_satisfiers" },
  {
    name: "Job Dissatisfiers",
    type: "paragraph",
    key: "job_dissatisfiers"
  },
  {
    name: "Appraiser Comments",
    type: "paragraph",
    key: "job_dissatisfiers_appraiser_comments",
    isMentorField: true,
    optional: true
  },
  { name: "What are your career goals?", type: "header" },
  {
    name: "Immediate goals (~1-2 years)",
    type: "paragraph",
    key: "immediate_goals"
  },
  {
    name: "Long term goals (~5 years)",
    type: "paragraph",
    key: "long_term_goals"
  },
  {
    name: "Appraiser Comments",
    type: "paragraph",
    key: "long_term_goals_appraiser_comments",
    isMentorField: true,
    optional: true
  },
  { name: "Goals & Objectives", type: "header" },
  {
    name: "Clinical Goals",
    type: "grid",
    columns: 2,
    rows: 2,
    sections: [
      {
        name: "Prior year goal(s)",
        type: "paragraph",
        child: true,
        orientation: "vertical",
        key: "clinical_goals_future_prev",
        optional: true,
        readOnly: true
      },
      {
        name: "Progress/Gap Analysis/Opportunities",
        type: "paragraph",
        orientation: "vertical",
        child: true,
        key: "clinical_goals_progress"
      },
      {
        name: "Future/Next Year Goal(s)",
        type: "paragraph",
        child: true,
        orientation: "vertical",
        key: "clinical_goals_future"
      },
      {
        name: "Comment(s)",
        type: "paragraph",
        child: true,
        orientation: "vertical",
        key: "clinical_goals_comment"
      }
    ]
  },
  {
    name: "Appraiser Comments",
    type: "paragraph",
    key: "clinical_goals_appraiser_comments",
    isMentorField: true,
    optional: true
  },
  {
    name: "Education and Research Goals",
    type: "grid",
    columns: 2,
    rows: 2,
    sections: [
      {
        name: "Prior year goal(s)",
        orientation: "vertical",
        type: "paragraph",
        child: true,
        optional: true,
        readOnly: true,
        key: "education_goals_future_prev"
      },
      {
        name: "Progress/Gap Analysis/Opportunities",
        orientation: "vertical",
        child: true,
        type: "paragraph",
        key: "education_goals_progress"
      },
      {
        name: "Future/Next Year Goal(s)",
        type: "paragraph",
        orientation: "vertical",
        child: true,
        key: "education_goals_future"
      },
      {
        name: "Comment(s)",
        type: "paragraph",
        child: true,
        orientation: "vertical",
        key: "education_goals_comment"
      }
    ]
  },
  {
    name: "Appraiser Comments",
    type: "paragraph",
    key: "edu_goals_appraiser_comments",
    isMentorField: true,
    optional: true
  },
  {
    name: "Academic Advancement Goals",
    type: "grid",
    columns: 2,
    rows: 2,
    sections: [
      {
        name: "Prior year goal(s)",
        type: "paragraph",
        child: true,
        optional: true,
        readOnly: true,
        orientation: "vertical",
        key: "academic_goals_future_prev"
      },
      {
        name: "Progress/Gap Analysis/Opportunities",
        type: "paragraph",
        child: true,
        orientation: "vertical",
        key: "academic_goals_progress"
      },
      {
        name: "Future/Next Year Goal(s)",
        type: "paragraph",
        child: true,
        orientation: "vertical",
        key: "academic_goals_future"
      },
      {
        name: "Comment(s)",
        type: "paragraph",
        child: true,
        orientation: "vertical",
        key: "academic_goals_comment"
      }
    ]
  },
  {
    name: "Appraiser Comments",
    type: "paragraph",
    key: "adv_goals_appraiser_comments",
    isMentorField: true,
    optional: true
  },
  {
    name: "Other Goals (specify)",
    type: "grid",
    columns: 2,
    rows: 2,
    sections: [
      {
        name: "Prior year goal(s)",
        type: "paragraph",
        child: true,
        optional: true,
        readOnly: true,
        orientation: "vertical",
        key: "other_goals_future_prev"
      },
      {
        name: "Progress/Gap Analysis/Opportunities",
        type: "paragraph",
        orientation: "vertical",
        child: true,
        key: "other_goals_progress"
      },
      {
        name: "Future/Next Year Goal(s)",
        type: "paragraph",
        orientation: "vertical",
        child: true,
        key: "other_goals_future"
      },
      {
        name: "Comment(s)",
        type: "paragraph",
        orientation: "vertical",
        child: true,
        key: "other_goals_comment"
      }
    ]
  },
  {
    name: "Appraiser Comments",
    type: "paragraph",
    key: "other_goals_appraiser_comments",
    isMentorField: true,
    optional: true
  },
  {
    name: "Please summarize comments for this evaluation period in 1-2 sentences (include honors, accomplishments if any)",
    type: "header"
  },
  {
    name: "Appraiser Comments",
    type: "paragraph",
    key: "appraiser_comments",
    isMentorField: true
  },
  {
    name: "Colleague Comments",
    type: "paragraph",
    key: "colleague_comments"
  }
];
